import Requisition from './requisition'
import workOrder from './work-order'
import Inspection from './inspection'
import News from './news'
import materialDownload from './materialdownload'

export default [
  {
    path: '/',
    redirect: 'Apps'
  },
  {
    path: '/Apps',
    component: () => import('@/views/apps'),
    children: [
      // 巡检模块
      ...Inspection,
      // 申请模块
      ...Requisition,
      // 工单模块
      ...workOrder,
      // 消息模块
      ...News,
      // 资料下载
      ...materialDownload
    ]
  }
]
